import React, { useState, useEffect } from 'react';
import {
  notification,
  Typography,
  Layout,
  Descriptions,
  Space,
  List,
} from 'antd';
import BreadcrumbContainer from '../../../containers/Breadcrumb';
import { CustomButton } from '../../../components';
import { Link } from 'react-router-dom';
import MESSAGES from '../../../enums/Messages';
import INTERNAL_LINKS from '../../../enums/InternalLinks';
import { get as getVDP } from '../../../api/module/term_document_validation';
import { getAllByValidation } from '../../../api/module/term_document_validation_email';
import dayjs from 'dayjs';

const breadcrumbItems = [
  {
    text: 'Validación de Documentos Precontractuales',
    to: `${INTERNAL_LINKS.DOCUMENT_VALIDATION_PRECONTRACTUAL}`,
  },
  {
    text: 'Historial de Correo',
  },
];

const { Title } = Typography;
const { Content } = Layout;

export default function DocumentValidationPrecontractualEmailHistory({
  match,
}) {
  const [validationData, setValidationData] = useState(undefined);
  const [dataSource, setDataSource] = useState(undefined);

  useEffect(() => {
    async function fetchData() {
      try {
        const validationId = match.params.validation_id;
        const res = await getVDP(validationId);
        const eList = await getAllByValidation(res.data.id);
        setValidationData(res.data);
        setDataSource(eList.data.results);
      } catch (err) {
        console.log(err);
        notification.error({
          message: MESSAGES.ERROR_MSG,
          description: MESSAGES.DESC_ERROR_GET_MSG,
          duration: 2,
        });
      }
    }
    fetchData();
  }, [match.params.validation_id]);

  return (
    <Content>
      <BreadcrumbContainer items={breadcrumbItems} />
      <Title className={'text-uppercase'} level={2}>
        Validación de Documentos Precontractuales
      </Title>
      {validationData && (
        <Space direction={'vertical'} style={{ width: '100%' }}>
          <Descriptions layout="vertical" column={2} bordered>
            <Descriptions.Item label="Proyecto a revisar">
              {validationData.proyecto_nombre}
            </Descriptions.Item>
            <Descriptions.Item label="Cargo/rol a revisar">
              {validationData.cargo_nombre}
            </Descriptions.Item>
            <Descriptions.Item label="Nombre completo/Razón social">
              {validationData.tercero.nombre_completo}
            </Descriptions.Item>
            <Descriptions.Item label="Tipo y número de documento">
              {`${validationData.tercero.tipo_identificacion_nombre} - ${validationData.tercero.numero_identificacion}`}
            </Descriptions.Item>
          </Descriptions>
          <Descriptions column={1} bordered layout="vertical">
            <Descriptions.Item label="Notificación">
              <List
                dataSource={dataSource}
                grid={{ gutter: [0, 24], column: 1 }}
                renderItem={(item, index) => (
                  <Content>
                    <Title level={5}>
                      Email No. {index + 1} - Enviado el:{' '}
                      {dayjs(item.created_at).format('DD MMMM YYYY h:mm a')}
                    </Title>
                    <div
                      key={`precontractual-email-history-${index}`}
                      dangerouslySetInnerHTML={{ __html: item.mensaje }}
                    />
                  </Content>
                )}
                pagination={false}
              />
            </Descriptions.Item>
          </Descriptions>
          <CustomButton
            type="default"
            htmlType="button"
            className={'back-button'}
            text={
              <Link
                to={`${INTERNAL_LINKS.DOCUMENT_VALIDATION_PRECONTRACTUAL}/role=${validationData.cargo}`}
              >
                Volver
              </Link>
            }
          />
        </Space>
      )}
    </Content>
  );
}
